
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/sentry.client.config.ts")
            }
          });